import { render, staticRenderFns } from "./HousingLimits.vue?vue&type=template&id=fdfeb446"
import script from "./HousingLimits.vue?vue&type=script&lang=js"
export * from "./HousingLimits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports